export default {
  meta: {
    title: '门店运营（慢闪店）'
  }
};
